const { isUndefined } = require('lodash');
const { STYLE_POSITION_ATTRIBUTES } = require('./constants');

/**
 * Returns a given variation root's position.
 * @param {Root} root
 * @returns {RootPosition}
 */
const getRootPosition = ({ style = {} } = {}) => STYLE_POSITION_ATTRIBUTES.reduce((acc, key) => Object.assign(acc, {
    ...(!isUndefined(style[key]) && { [key] : Number(parseFloat(style[key])) })
}), {});

module.exports = getRootPosition;
